<mat-icon class="alert-icon">warning</mat-icon>
<span class="flex-1">{{ alert }}</span>
<ng-content />
